const EyerPasswordSvg = (props: any) => {
  return (
    <svg
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 7C12 7.53043 11.7893 8.03914 11.4142 8.41421C11.0391 8.78929 10.5304 9 10 9C9.46957 9 8.96086 8.78929 8.58579 8.41421C8.21071 8.03914 8 7.53043 8 7C8 6.46957 8.21071 5.96086 8.58579 5.58579C8.96086 5.21071 9.46957 5 10 5C10.5304 5 11.0391 5.21071 11.4142 5.58579C11.7893 5.96086 12 6.46957 12 7V7Z"
        fill="#343C44"
      />
      <path
        d="M0 7C0 7 3.75 0 10 0C16.25 0 20 7 20 7C20 7 16.25 14 10 14C3.75 14 0 7 0 7ZM10 11.4545C11.1603 11.4545 12.2731 10.9852 13.0936 10.1498C13.9141 9.31445 14.375 8.18142 14.375 7C14.375 5.81858 13.9141 4.68555 13.0936 3.85016C12.2731 3.01477 11.1603 2.54545 10 2.54545C8.83968 2.54545 7.72688 3.01477 6.90641 3.85016C6.08594 4.68555 5.625 5.81858 5.625 7C5.625 8.18142 6.08594 9.31445 6.90641 10.1498C7.72688 10.9852 8.83968 11.4545 10 11.4545V11.4545Z"
        fill="#343C44"
      />
    </svg>
  )
}

export default EyerPasswordSvg
